// @flow

import React, { PureComponent } from 'react';
import cx from 'classnames';
import Translate from 'client/components/translate';
import type { TranslateType } from 'types/translateType.flow';
import type { InputProps } from 'redux-form/lib/FieldProps.types.js.flow';

type ValuePropType = string | number | boolean;

export type OptionType = {
  value: ValuePropType,
  label: string,
};

export type SegmentProps = {
  ...$Exact<InputProps>,
  clickHandler: Function,
  options: Array<{
    value: ValuePropType,
    label: string,
  }>,
  id: string,
  value: ValuePropType | null,
  label: TranslateType | null,
  info: TranslateType | null,
  error: TranslateType | false,
  suppressError: boolean,
};

class Segment extends PureComponent<SegmentProps> {
  static defaultProps = {
    error: false,
    info: null,
    label: null,
    suppressError: false,
    value: null,
  };

  render() {
    const { options, clickHandler, value, id, label, error, info, suppressError } = this.props;

    return (
      <div className={cx('segment-container', { error })}>
        {!!label && (
          <div className="label-container">
            <label htmlFor={id}>
              <Translate {...label} />
            </label>
          </div>
        )}
        <div className="segment">
          {options.map(option => (
            <button
              key={typeof option.value === 'boolean' ? option.value.toString() : option.value}
              className={cx({ selected: option.value === value })}
              onClick={(e) => {
                e.preventDefault();
                clickHandler(option.value);
              }}>
              <div className="pad-x text-center">{option.label}</div>
            </button>
          ))}
        </div>
        {info ? (
          <div className="info-message">{info && <Translate {...info} />}</div>
        ) : (
          <div className="error-message">{error && !suppressError && <Translate {...error} />}</div>
        )}
      </div>
    );
  }
}

export default Segment;
